<div class="no-featured-cards cashback-cards" *ngIf="partners?.length">
  <div class="title-content">
    <img class="cashback-title-icon" src="assets/shared/img/partners/iconografia-cashback-title.svg" alt="" />
    <p>Cashback</p>
    <a (click)="openAll()">Ver mais<span class="fa fa-angle-right"></span></a>
  </div>

  <div class="grid-content">
    <article class="card-container cashback-card" *ngFor="let partner of partners">
      <div class="premium-badge cashback-badge">
        <img src="assets/shared/img/partners/iconografia-cashback.svg" alt="Cashback" />
      </div>

      <div class="card-wrapper">
        <a
          class="image-card"
          *ngIf="partner.logoUrl"
          (click)="openPartner(partner)"
          [ngStyle]="{ 'background-image': 'url(' + partner.logoUrl + ')' }"
        ></a>
        <a
          class="image-card cashback-initial"
          *ngIf="!partner.logoUrl"
          (click)="openPartner(partner)"
        >{{ getInitial(partner) }}</a>

        <div class="card-content online">
          <div class="card-content-wrapper">
            <a (click)="openPartner(partner)">
              <h2
                tooltip="{{ partner.name }}"
                placement="bottom"
                show-delay="50"
                tooltip-class="tooltip-online"
              >
                {{
                  partner.name.length > 23
                    ? (partner.name | slice : 0 : 22) + "..."
                    : partner.name
                }}
              </h2>
            </a>
            <p class="cashback-rate" *ngIf="formatRate(partner.cashback) as rate">{{ rate }}</p>
          </div>
        </div>
      </div>
    </article>
  </div>
</div>
